import { AlertSourceType } from 'src/app/models/alert';

export interface AlertSourceTypeVM {
  icon: string;
  /** Product name, not translated. */
  label: string;
}

const FALLBACK: AlertSourceTypeVM = {
  icon: '/assets/images/logos/incidite-head-color.svg',
  label: 'Incidite',
};

const SOURCE_TYPES: Partial<Record<AlertSourceType, AlertSourceTypeVM>> = {
  [AlertSourceType.ALERTMANGER]: {
    icon: '/assets/images/icons/prometheus.svg',
    label: 'Alertmanager',
  },
  [AlertSourceType.INCIDITE]: FALLBACK,
};

/** Logo and display name of an alert source type, shared by the alerting pages. */
export function alertSourceTypeVM(type: AlertSourceType): AlertSourceTypeVM {
  return SOURCE_TYPES[type] ?? { ...FALLBACK, label: type };
}
